import React from "react";
import { useQuery } from "@tanstack/react-query";
import PricingCard from "../pages/LandingPage/components/PricingCard";
import { Link } from "react-router-dom";
import { PlanDetails } from "@mysnowscape/snow-lib/dist/types/pricing";

const AddOnPricing = {
  extra_users: {
    name: "Extra Users",
    id: "extra_users",
    price: 11.99,
  },
  extra_companies: {
    name: "Extra Companies",
    id: "extra_companies",
    price: 49.99,
  },
};
const Pricing = ({
  onPlanSelect,
  buttonText,
}: {
  onPlanSelect: (id: string) => void;
  buttonText: string;
}) => {
  const { data } = useQuery<{ plans: PlanDetails[] }>({
    queryKey: ["stripe/pricing"],
  });
  const plans: PlanDetails[] = (data?.plans ?? []).filter(
    (p) => !p.id.startsWith("park-mode"),
  );
  return (
    <>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-4 mt-10">
        {plans.map((plan) => (
          <PricingCard
            key={plan.name}
            price={plan.price === 0 ? "free" : plan.price}
            title={plan.name}
            details={[
              plan.allowances.authorizedCompanies + " Company",
              plan.allowances.authorizedUsers + " User",
              plan.allowances.siteMaps + " Site Maps",
              plan.allowances.optimizations + " Route Optimizations",
            ]}
            subtext="Add extra users for $11.99 / user"
            onClick={() => onPlanSelect(plan.id)}
            buttonText={buttonText}
            recommended={plan.default === true}
          />
        ))}
      </div>
      <div className="mx-auto mt-4 text-xl font-light mb-8 text-center">
        Get started with a <b>7 day free trial</b> today!
        <br />
        Not seeing a tier that's right for you?{" "}
        <Link to="/pricing/quote" className="underline">
          Get a quote
        </Link>
        .
      </div>
      <p className="max-w-[800px] mx-auto text-sm">
        All our plans support adding extra users for $11.99 / user / month or
        extra companies at $49.99 / company / month. After signing up, you can
        modify your subscription to add extra users / companies - or just shoot
        us an email and we will do it for you!
      </p>
    </>
  );
};

export default Pricing;
export { AddOnPricing };
